import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Dimmer as BaseDimmer } from 'semantic-ui-react';
import styled from 'styled-components';

import { Box, AspectRatio, BackgroundImage } from 'Components/Base';
import FileUploadManagerModal from 'Components/Lib/UploadComponent';

const Dimmer = styled(BaseDimmer)`
  && {
    z-index: ${({ theme }) => theme.zIndices.imageUploadOverlay};
  }
`;

class SKUImageUploadView extends Component {
  static propTypes = {
    imageUrl: PropTypes.string,
    changeImgText: PropTypes.string,
    onFileListRequest: PropTypes.func,
    onFileUploadUrlRequest: PropTypes.func,
    onImageUpdate: PropTypes.func,
  };

  static defaultProps = {
    changeImgText: 'Change course image',
    imageUrl: '/square-image.png',
    onFileListRequest: () => {},
    onFileUploadUrlRequest: () => {},
    onImageUpdate: () => {},
  };

  state = {
    active: false,
  };

  handleHover = (active) => {
    this.setState({ active: active });
  };

  handleSelectImage = (files = []) => {
    if (files && files.length > 1) {
      // Now Support only one file upload
      alert('Please select only 1 file');
    }
    if (files && files.length === 1) {
      // Now Support only one file upload
      const { key, bucket, url } = files[0];
      this.props.onImageUpdate({ key, bucket, url });
      this.handleHover(false);
    }
  };

  render() {
    const {
      imageUrl = '/square-image.png',
      onFileListRequest,
      onFileUploadUrlRequest,
      assetUploadMode,
      changeImgText,
    } = this.props;
    const { active } = this.state;
    return (
      <Box
        onMouseOver={() => {
          this.handleHover(true);
        }}
        onMouseLeave={() => {
          this.handleHover(false);
        }}
        style={{ cursor: 'pointer' }}
      >
        <FileUploadManagerModal
          keyGroup="courseImage"
          dimmer="inverted"
          uploadUrl={'http://localhost:5000'}
          listUrl={'http://localhost:5000'}
          allowedContentTypes={['image/png', 'image/jpeg', 'image/gif']}
          defaultText={`Support JPG, PNG or GIF file with less than 5MB <br /><br /><p style='color:red;'>*** ชื่อไฟล์ต้องไม่มี spaces ***</p>`}
          maxFileSize={5}
          maxSelection={1}
          customFileListUrlRequest={onFileListRequest}
          customUploadUrlRequest={onFileUploadUrlRequest}
          mode={assetUploadMode}
          onFileManagerDialogClose={this.handleSelectImage}
          trigger={
            //Put it here to allow user to click any where in picture to change image
            <Dimmer.Dimmable dimmed={active}>
              <AspectRatio ratio={16 / 9}>
                <BackgroundImage imageUrl={imageUrl} bgPosition={'center'} bgSize={'contain'} />
                <Dimmer active={active}>
                  <Button primary>
                    <Icon name="image outline" />
                    {changeImgText}
                  </Button>
                </Dimmer>
              </AspectRatio>
            </Dimmer.Dimmable>
          }
        />
      </Box>
    );
  }
}

export default SKUImageUploadView;
